import { BorderBox } from "@/components/atoms/BorderBox";
import { OldNewValueChangeProps } from ".";
import { PencilLine } from "lucide-react";

export function OldNewValueChange({label, oldValue, newValue, valueName, oldLabel = "Old", newLabel = "New"}:OldNewValueChangeProps) {
    return (
        <BorderBox size={"xs"} className="flex flex-col items-start bg-white" >
            <h4 className="w-full flex gap-1 items-center font-semibold text-red-500"><PencilLine size="14"/>{label}</h4>
            <div className="grid w-full grid-cols-2 gap-2">
                <div className="flex flex-col">
                    <span className="text-muted-foreground">{oldLabel} {valueName}</span>
                    <span className="font-semibold">{oldValue || '<empty>'}</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-muted-foreground">{newLabel} {valueName}</span>
                    <span className="font-semibold">{newValue || '<empty>'}</span>
                </div>
            </div>
        </BorderBox>
    )
}